import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Spinner, ListGroup } from "react-bootstrap";
import * as gastosEsporadicosApi from "../../api/gastosEsporadicos";
import { formatoNumero } from "../../utils/moneda";

const FORMAS_PAGO = ["Tarjeta", "Bizum", "Transferencia"];

/** Barra para registrar gastos esporádicos del mes (monto + motivo + forma de pago) que descuentan el saldo actual. */
export default function GastosEsporadicosPanel({ cuentaId, onCambio }) {
  const [gastos, setGastos] = useState([]);
  const [motivo, setMotivo] = useState("");
  const [monto, setMonto] = useState("");
  const [formaPago, setFormaPago] = useState(FORMAS_PAGO[0]);
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [expandido, setExpandido] = useState(false);

  const cargar = async () => {
    if (!cuentaId) return;
    setCargando(true);
    try {
      const hoy = new Date();
      setGastos(await gastosEsporadicosApi.listarGastosEsporadicosRecientes(cuentaId, hoy.getMonth() + 1, hoy.getFullYear()));
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, [cuentaId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAgregar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await gastosEsporadicosApi.registrarGastoEsporadico({ cuentaId, monto: Number(monto), motivo, formaPago });
      setMotivo(""); setMonto(""); setFormaPago(FORMAS_PAGO[0]);
      await cargar();
      onCambio?.();
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    await gastosEsporadicosApi.eliminarGastoEsporadico(id);
    await cargar();
    onCambio?.();
  };

  return (
    <div className="fs-card mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="fw-semibold"><i className="bi bi-cart text-fs-gasto me-2"></i>Gastos esporádicos del mes</div>
        <Button size="sm" variant="link" className="text-decoration-none" onClick={() => setExpandido((v) => !v)}>
          {expandido ? "Ocultar historial" : "Ver historial"}
        </Button>
      </div>

      <Form onSubmit={handleAgregar}>
        <div className="row g-2 align-items-end">
          <div className="col-12 col-sm-4">
            <Form.Control value={motivo} onChange={(e) => setMotivo(e.target.value)} required placeholder="Motivo (supermercado, taxi...)" />
          </div>
          <div className="col-6 col-sm-3">
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control type="number" step="0.01" min="0.01" value={monto} onChange={(e) => setMonto(e.target.value)} required />
            </InputGroup>
          </div>
          <div className="col-6 col-sm-3">
            <Form.Select value={formaPago} onChange={(e) => setFormaPago(e.target.value)} required>
              {FORMAS_PAGO.map((f) => <option key={f} value={f}>{f}</option>)}
            </Form.Select>
          </div>
          <div className="col-12 col-sm-2">
            <Button type="submit" variant="primary" className="w-100" disabled={guardando}>
              {guardando ? <Spinner size="sm" animation="border" /> : "Agregar"}
            </Button>
          </div>
        </div>
      </Form>

      {expandido && (
        <ListGroup variant="flush" className="mt-3">
          {cargando ? <Spinner animation="border" size="sm" /> : (
            gastos.length ? gastos.map((g) => (
              <ListGroup.Item key={g.gastoEsporadicoId} className="d-flex justify-content-between align-items-center px-0">
                <div>
                  <div>{g.motivo} <span className="text-muted small">· {g.formaPago}</span></div>
                  <div className="text-muted small">{new Date(g.fecha).toLocaleDateString("es-ES")}</div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-fs-gasto fw-semibold">-${formatoNumero(g.monto)}</span>
                  <Button size="sm" variant="outline-danger" onClick={() => eliminar(g.gastoEsporadicoId)}>
                    <i className="bi bi-trash"></i>
                  </Button>
                </div>
              </ListGroup.Item>
            )) : <div className="text-muted small py-2">Sin gastos esporádicos registrados este periodo.</div>
          )}
        </ListGroup>
      )}
    </div>
  );
}
